import { render, staticRenderFns } from "./socket-status.vue?vue&type=template&id=016ac39a&scoped=true&"
import script from "./socket-status.vue?vue&type=script&lang=js&"
export * from "./socket-status.vue?vue&type=script&lang=js&"
import style0 from "./socket-status.vue?vue&type=style&index=0&id=016ac39a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ac39a",
  null
  
)

export default component.exports